import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    leavesData:[]
}

const leaveSlice = createSlice({
  name: "Leave",
  initialState: initialState,
  reducers: {
    setLeaves(state, value) {
      state.leavesData = value.payload;
    }
  },
});

export const { setLeaves} = leaveSlice.actions;

export default leaveSlice.reducer;